import { SearchableSelect } from "@risalabs_frontend_org/oasis-ui-kit";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "risa-oasis-ui_v2";
import { ScreenNamesForBigQuery } from "../../../enums/eventsData";
import { EventsName } from "../../../enums/eventsName";
import { RootState } from "../../../redux/store/store";
import WarningIcon from "../../../svg/warningIcon";
import { generateFullName } from "../../../utils/generateOrderDataForTable";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";

import {
  BULK_REASSIGN_MODAL_CANCEL_BUTTON_TEXT,
  BULK_REASSIGN_MODAL_SAVE_BUTTON_TEXT,
  BULK_REASSIGN_MODAL_SELECT_PROVIDER_TEXT,
  BULK_REASSIGN_MODAL_TITLE,
  BULK_REASSIGN_MODAL_WARNING_TEXT,
  LOADING_TEXT_FOR_BUTTON,
  REASSIGN_MODAL_SELECT_MEMBER_TEXT,
  UNASSIGNED_TEXT,
  UNASSIGNED_TEXT_LABEL,
} from "../../../constants/stringLiterals";
import { isValidString } from "../../../utils/stringModifications";
import { apiWorkerManager } from "../../../workerManagers/workerManager";
interface BulkReassignModalProps {
  onClose: () => void;
  onSave: (selectedProvider: string) => void;
  isLoading: boolean;
  shouldLogEvent?: boolean;
}

const BulkReassignModal = (props: BulkReassignModalProps) => {
  const { data: providersDetails } = useSelector(
    (state: RootState) => state.allProviders,
  );
  const [selectedProvider, setSelectedProvider] = useState<string>("");
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );
  const orgId = getOrgIdForFetchExternalWorklist();
  const options = useMemo(() => {
    const providerOptions =
      providersDetails
        ?.map((provider) => {
          return {
            value: provider.id,
            label: generateFullName(
              provider.FirstName || provider.name || "",
              "",
              provider?.LastName || "",
            ),
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label)) || [];
    return [
      ...providerOptions,
      {
        value: UNASSIGNED_TEXT,
        label: UNASSIGNED_TEXT_LABEL,
      },
    ];
  }, [providersDetails]);

  return (
    <Modal
      dialogId={`bulk-reassign-modal`}
      title={BULK_REASSIGN_MODAL_TITLE}
      saveButtonText={
        props.isLoading
          ? LOADING_TEXT_FOR_BUTTON
          : BULK_REASSIGN_MODAL_SAVE_BUTTON_TEXT
      }
      onSave={() => props.onSave(selectedProvider)}
      cancelText={BULK_REASSIGN_MODAL_CANCEL_BUTTON_TEXT}
      onClose={props.onClose}
      onCancel={props.onClose}
      disableSave={props.isLoading || !isValidString(selectedProvider)}
    >
      <div className="bulk-assign-order__container flex flex-col gap-2">
        <div className="bulk-assign-order__warning flex items-start justify-center gap-2 rounded-md bg-secondaryYellow-11 p-4">
          <WarningIcon height="20" width="20" />

          <div className="bulk-assign-order__warning-text text-small">
            {BULK_REASSIGN_MODAL_WARNING_TEXT}
          </div>
        </div>
        <div className="bulk-assign-order__providers flex flex-col gap-2">
          <div className="bulk-assign-order__provider-text text-small font-semibold text-primaryGray-1">
            {BULK_REASSIGN_MODAL_SELECT_PROVIDER_TEXT}
          </div>
          <SearchableSelect
            id="provider"
            onOptionChange={(option) => {
              if (props.shouldLogEvent) {
                apiWorkerManager.enqueueAndProcess({
                  event_name: EventsName.BULK_ASSIGN_BUTTON_CLICKED,
                  patient_id: "",
                  order_id: "",
                  user_id: user?.id ?? "",
                  user_email: user?.email ?? "",
                  org_id: orgId ?? "",
                  additional_data: {
                    screen_name: ScreenNamesForBigQuery.WORKLIST,
                    user_id: user?.id ?? "",
                    assigned_to: option.value,
                  },
                });
              }
              setSelectedProvider(option.value);
            }}
            label=""
            placeholder={REASSIGN_MODAL_SELECT_MEMBER_TEXT}
            searchPlaceholder="Search providers"
            value={selectedProvider}
            options={options ?? []}
          />
        </div>
      </div>
    </Modal>
  );
};

export default BulkReassignModal;
